export const DEMAND_BY_YEAR = {
  1: 12,
  2: 25,
  3: 45
};

export const DEMAND_YEARS = [1, 2, 3];
